import * as fromDatatype from "../datatype-library";

export interface bl_fi_generic_doc_budget_sub_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  budget_votebook_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_name: fromDatatype.VarcharDatatypeInterface;
  budget_register_name: fromDatatype.VarcharDatatypeInterface;
  budget_fiscal_period_name: fromDatatype.VarcharDatatypeInterface;
  budget_fiscal_year_name: fromDatatype.VarcharDatatypeInterface;
  budget_votebook_name: fromDatatype.VarcharDatatypeInterface;
  budget_amount: fromDatatype.NumericDatatypeInterface;
  budget_register_balance_amt: fromDatatype.NumericDatatypeInterface;
  budget_register_percentage: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_generic_doc_budget_sub_line_RowClass implements bl_fi_generic_doc_budget_sub_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  budget_votebook_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_name: fromDatatype.VarcharDatatypeInterface;
  budget_register_name: fromDatatype.VarcharDatatypeInterface;
  budget_fiscal_period_name: fromDatatype.VarcharDatatypeInterface;
  budget_fiscal_year_name: fromDatatype.VarcharDatatypeInterface;
  budget_votebook_name: fromDatatype.VarcharDatatypeInterface;
  budget_amount: fromDatatype.NumericDatatypeInterface;
  budget_register_balance_amt: fromDatatype.NumericDatatypeInterface;
  budget_register_percentage: fromDatatype.NumericDatatypeInterface;
}
